import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      className="max-w-md mx-auto px-5 md:px-8 py-20 text-white"
      data-testid="admin-login-page"
    >
      <div className="text-xs uppercase tracking-[0.35em] text-axe-tangerine font-bold">
        Staff · Access
      </div>
      <h1 className="mt-3 font-display font-black text-3xl sm:text-4xl">Admin Login</h1>

      <form
        onSubmit={submit}
        className="mt-10 bg-axe-surface border border-axe-border rounded-2xl p-7 space-y-5"
        data-testid="admin-login-form"
      >
        <div>
          <Label className="text-xs uppercase tracking-[0.25em] text-neutral-400">Email</Label>
          <Input
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 bg-[#121212] border-axe-border rounded-xl text-white h-12 px-4"
            placeholder="you@example.com"
            data-testid="admin-email"
          />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-[0.25em] text-neutral-400">Password</Label>
          <Input
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 bg-[#121212] border-axe-border rounded-xl text-white h-12 px-4"
            placeholder="••••••••"
            data-testid="admin-password"
          />
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="w-full rounded-full bg-axe-purple py-3.5 font-bold uppercase tracking-[0.22em] text-white hover:bg-axe-purple-hover transition-colors disabled:opacity-50"
          data-testid="admin-login-submit"
        >
          {submitting ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
